import { CustomerLogoView } from "@/pages/customer/components/CustomerDrawer/CustomerLogoView";
import { useTrans } from "@/translations";

import { twMerge } from "tailwind-merge";

import type { MetricConfig, RankedTenant } from "../types";
import { RankCell } from "./rankCell";
import { RatingChangeCell } from "./ratingChangeCell";

type Props = {
  index: number;
  tenant: RankedTenant;
  cfg: MetricConfig;
  rank: number;
  top: boolean;
};

export const LeaderboardRow: React.FC<Props> = ({
  index,
  tenant,
  cfg,
  rank,
  top,
}) => {
  const { t } = useTrans();
  return (
    <div
      key={tenant.id}
      className={twMerge(
        "flex items-center gap-[8.25px] py-[8.25px] @max-[360px]/lb:gap-[8px] @max-[360px]/lb:py-[7px] @max-[300px]/lb:py-[6px]",
        index > 0 && "border-grey2 border-t",
      )}
    >
      <RankCell rank={rank} top={top} />
      <RatingChangeCell mv={tenant.mv} />
      <CustomerLogoView
        customerId={tenant.id}
        customerName={tenant.name}
        size={30}
        className=""
        editable={false}
      />
      <span className="min-w-0 flex-1 truncate text-[14.5px] font-bold @max-[360px]/lb:text-[13px] @max-[300px]/lb:text-[12px]">
        {tenant.name}
        <span className="text-grey4 ml-1 text-[10px]">
          {tenant.isDeleted && `(${t("common:deleted")})`}
        </span>
      </span>
      <span className="flex-none text-[14.5px] font-bold whitespace-nowrap @max-[360px]/lb:text-[13px] @max-[300px]/lb:text-[12px]">
        {cfg.format(tenant)}
      </span>
    </div>
  );
};
